export const statuses = [
  'positive',
  'negative',
  'info',
  'warning',
  'unknown',
] as const;
export type TStatus = (typeof statuses)[number];
